/**
 * The in-reach cue (ROUND7 §2): a small bracket under the feet of the man a stab would take right now, whatever
 * weapon is out - the Quick Knife works from any of them. The app asks the sim's own `knifeTarget`, so what the
 * bracket promises and what the blade does cannot drift apart. World-anchored through the HUD's projector; no
 * projector, or a man off the image, and it is simply not drawn.
 */

import './knifeMark.css';
import { el, show, Shown } from '../dom';
import { type HudFrame, type Point, type Projector, toLogical } from './projection';

export class KnifeMark {
  readonly el: HTMLElement;
  private readonly shown = new Shown();
  private projector: Projector | null = null;
  private frame: HudFrame = { left: 0, top: 0, scale: 1 };

  constructor() {
    this.el = el('div', 'hud-knife hud-hidden');
    this.el.setAttribute('aria-hidden', 'true');
  }

  setProjector(projector: Projector | null): void {
    this.projector = projector;
  }

  /** Where `Hud.layout` put the HUD. */
  setFrame(frame: HudFrame): void {
    this.frame = frame;
  }

  /** The ground point his feet are drawn at (x, z), or null for nobody in reach. */
  set(target: { x: number; z: number } | null): void {
    const hit = target !== null && this.projector !== null ? this.projector(target.x, target.z) : null;
    const at: Point | null = hit !== null && this.frame.scale > 0 ? toLogical(hit, this.frame) : null;
    if (this.shown.changed('on', at !== null)) show(this.el, at !== null);
    if (at === null) return;
    const x = Math.round(at.x);
    const y = Math.round(at.y);
    if (this.shown.changed('at', `${x},${y}`)) {
      this.el.style.left = `${x}px`;
      this.el.style.top = `${y}px`;
    }
  }
}
